export const TOKEN_COOKIE_NAME = "JWT_TOKEN_KEY_VALUE";